import React, { FC, ReactNode } from 'react';
import { Tabs } from 'antd';
import styles from './tabsComponent.module.scss';
import clsx from 'clsx';
import { defaultYearTab } from 'constants/constants';

const { TabPane } = Tabs;

interface TabItem {
  key?: string;
  label?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode; // Optional icon
}

interface YearTabProps {
  tabs: TabItem[];
  activeTab: string;
  onTabChange?: (key: string) => void;
  isMainTab?: boolean;
  haveAddButton?: boolean;
  icon?: ReactNode;
  addText?: string;
  haveLocationTab?: boolean;
  locationText?: string;
  locationChildren?: ReactNode;
  tabBarExtraContent?: ReactNode;
  destroyInactiveTabPane?: boolean;
}

const TabsComponent: FC<YearTabProps> = ({
  tabs,
  activeTab,
  onTabChange,
  isMainTab,
  haveAddButton,
  addText,
  haveLocationTab,
  locationText,
  locationChildren,
  destroyInactiveTabPane = false,
  tabBarExtraContent,
}) => {
  return (
    <div
      className={clsx(
        isMainTab
          ? styles.mainTabComponentContainer
          : styles.tabComponentContainer
      )}>
      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        tabBarGutter={-8}
        tabBarExtraContent={tabBarExtraContent}
        destroyInactiveTabPane={destroyInactiveTabPane}
        className={styles.scopeTabs}>
        {haveLocationTab && (
          <TabPane
            key={defaultYearTab}
            tab={locationText ?? 'Location Details'}>
            {locationChildren}
          </TabPane>
        )}
        {haveAddButton && (
          <TabPane
            key={'addButton'}
            className={styles.addButton}
            tab={addText ?? '+ Add Year'}
          />
        )}
        {tabs.map(tab => (
          <TabPane
            tab={
              <>
                {tab.icon && <span className={styles.tabIcon}>{tab.icon}</span>}
                {tab.label}
              </>
            }
            key={tab.key}>
            {tab.children}
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default TabsComponent;
